import React, {useRef, useEffect, useState, useCallback} from 'react';
import { defineBlock, useEditor, smartProps } from '@smartfire/wordpress-react';
import useChildrenBlocks from '../shared/useChildrenBlocks';
import qs from 'qs';
import style from './block.module.scss';

const template = [
    ['smartfire/tab', {}],
    ['smartfire/tab', {}]
]

const Tabs = ({ tabLibelle }) => {
    const { isEditing } = useEditor();
    const ref = useRef();
    const { Children, Child, domChildren } = useChildrenBlocks({ nodeRef: ref });
    const [paramsUrl, setParamsUrl] = useState({});
    const [attributes, setAttributes] = useState([]);

    const getAttributes = useCallback(() => {
        const attrs = domChildren && domChildren.map((el, index) => {
            let attr = Array.from(el.attributes)
            if (attr.length > 2) {
                return {
                    param: attr[2].value,
                    label: attr[3].value
                }
            }
            return []
        })
        return attrs
    }, [domChildren])

    useEffect(() => {
        let attrs = [];
        if (ref.current) {
            attrs = getAttributes();
            setAttributes(attrs)
        }
    }, [domChildren, ref, getAttributes])

    useEffect(() => {
        let query = qs.parse(window.location.search, { ignoreQueryPrefix: true })
        if (query && attributes && attributes.length > 0) {
            if (Object.keys(query).length === 0) {
                query = {
                    tab: attributes[0].param
                }
            }
            setParamsUrl(query)
        }
    }, [setParamsUrl, attributes])

    const tabClick = (param) => {
        let controller = {...paramsUrl}
        controller.tab = param

        let query = window.location.pathname + qs.stringify(controller, { addQueryPrefix: true })
        if ( window.history.state === null || window.history.state.path !== query) {
            window.history.replaceState({path:query},'',query);
        }

        setParamsUrl(controller)
    }

    return (
        <div className={style.block} ref={ref}>

            {isEditing &&
                <Children 
                    allowedBlocks={['smartfire/tab']} 
                    template={template}
                />
            }

            <ul 
                className={style.tabs}
                role={"tablist"}
            >
                {attributes && attributes.map((attr, index) => (
                    <li 
                        key={index} 
                        className={paramsUrl.tab === attr.param && style.active }
                        onClick={() => tabClick(attr.param)}
                        role="tab"
                        aria-selected={paramsUrl.tab === attr.param ? "true" : "false"}
                        id={'tab-' + attr.param}
                        tabindex={paramsUrl.tab === attr.param ? 0 : -1}
                    >
                        <div className={style.label}>
                            {attr.label}
                        </div>
                    </li>
                ))}
            </ul>

            <div className={style.tabsContent}>
                {attributes && attributes.map((attr, index) => (
                    <div className={paramsUrl.tab === attr.param ? style.active : style.fade}>
                        <Child 
                            index={index}
                        />
                    </div>
                ))}
            </div>

        </div>
    )
}

export default defineBlock ({
    Block: Tabs,
    smartProps: {
        tabLibelle: smartProps.array.withDefault([])
    },
    setup: {
        title: 'Onglets'
    }
})